import { render } from "./MirabelProgressBar.vue?vue&type=template&id=0233630b&scoped=true"
import script from "./MirabelProgressBar.vue?vue&type=script&lang=js"
export * from "./MirabelProgressBar.vue?vue&type=script&lang=js"

import "./MirabelProgressBar.vue?vue&type=style&index=0&id=0233630b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0233630b"]])

export default __exports__